import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { timer } from "rxjs";
import { map } from "rxjs/operators";
import { ISelfServMeta } from "../models";
import { DatePipe } from "@angular/common";

/**
 * Display copyright message
 */
@Component({
  selector: "aa-advice-footer",
  templateUrl: "./advice-footer.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe],
})
export class AdviceFooterComponent implements OnInit {
  // sync date at startup and then every minute in case people keep the page open
  public readonly today = toSignal(
    timer(0, 60000).pipe(map(() => Date.now())),
    {
      initialValue: Date.now(),
    },
  );

  @Input({ required: true }) meta: ISelfServMeta | null = null;

  public telephone?: string;
  public url?: string;

  public ngOnInit(): void {
    if (!this.meta) {
      return;
    }

    this.url = this.meta.url;

    if (this.meta.contact) {
      this.telephone = this.meta.contact.telephone;
    }
  }
}
